import { render, staticRenderFns } from "./latestBetting.vue?vue&type=template&id=753c7ef4&scoped=true&"
import script from "./latestBetting.vue?vue&type=script&lang=js&"
export * from "./latestBetting.vue?vue&type=script&lang=js&"
import style0 from "./latestBetting.vue?vue&type=style&index=0&id=753c7ef4&prod&lang=less&"
import style1 from "./latestBetting.vue?vue&type=style&index=1&id=753c7ef4&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "753c7ef4",
  null
  
)

export default component.exports